var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2H11.5V1.5C11.5 1.36739 11.4473 1.24021 11.3536 1.14645C11.2598 1.05268 11.1326 1 11 1C10.8674 1 10.7402 1.05268 10.6464 1.14645C10.5527 1.24021 10.5 1.36739 10.5 1.5V2H5.5V1.5C5.5 1.36739 5.44732 1.24021 5.35355 1.14645C5.25979 1.05268 5.13261 1 5 1C4.86739 1 4.74021 1.05268 4.64645 1.14645C4.55268 1.24021 4.5 1.36739 4.5 1.5V2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2ZM4.5 3V3.5C4.5 3.63261 4.55268 3.75979 4.64645 3.85355C4.74021 3.94732 4.86739 4 5 4C5.13261 4 5.25979 3.94732 5.35355 3.85355C5.44732 3.75979 5.5 3.63261 5.5 3.5V3H10.5V3.5C10.5 3.63261 10.5527 3.75979 10.6464 3.85355C10.7402 3.94732 10.8674 4 11 4C11.1326 4 11.2598 3.94732 11.3536 3.85355C11.4473 3.75979 11.5 3.63261 11.5 3.5V3H13V5H3V3H4.5ZM13 13H3V6H13V13ZM10.6038 7.64625C10.6502 7.69269 10.6871 7.74783 10.7123 7.80853C10.7374 7.86923 10.7504 7.93429 10.7504 8C10.7504 8.06571 10.7374 8.13077 10.7123 8.19147C10.6871 8.25217 10.6502 8.30731 10.6038 8.35375L7.60375 11.3538C7.55731 11.4002 7.50217 11.4371 7.44147 11.4623C7.38077 11.4874 7.31571 11.5004 7.25 11.5004C7.18429 11.5004 7.11923 11.4874 7.05853 11.4623C6.99783 11.4371 6.94269 11.4002 6.89625 11.3538L5.39625 9.85375C5.30243 9.75993 5.24972 9.63268 5.24972 9.5C5.24972 9.36732 5.30243 9.24007 5.39625 9.14625C5.49007 9.05243 5.61732 8.99972 5.75 8.99972C5.88268 8.99972 6.00993 9.05243 6.10375 9.14625L7.25 10.2931L9.89625 7.64625C9.94269 7.59976 9.99783 7.56288 10.0585 7.53772C10.1192 7.51256 10.1843 7.49961 10.25 7.49961C10.3157 7.49961 10.3808 7.51256 10.4415 7.53772C10.5022 7.56288 10.5573 7.59976 10.6038 7.64625Z",
    fill: "url(#paint0_linear_321_11411)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_321_11411",
    x1: 14,
    y1: 1,
    x2: 2,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465749,
    stopColor: "#8937A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455AC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/CalendarCheck.d63a707e87463477fd840a070f6cb4a6.svg";
export { ForwardRef as ReactComponent };